import BaseStore from 'fluxible/addons/BaseStore';

export default class UserStore extends BaseStore {
    static storeName = 'UserStore';

    static handlers: { [key: string]: keyof UserStore } = {
        LOAD_USER_DATA: 'load',
        DISMISS_AUTH_MODAL: 'dismissAuthModal',
        SHOW_AUTH_MODAL: 'showAuthModal',
    };

    loggedIn = false;
    isAuthModalHidden = true;
    language: string = '';
    country: string = '';
    isGDPRApplicable = false;

    load(data: { isLoggedIn: boolean; locale: string; isGDPRApplicable: boolean }) {
        this.loggedIn = data.isLoggedIn;

        const [language, country] = data.locale.split('-');
        this.country = country;
        this.language = language;
        this.isGDPRApplicable = data.isGDPRApplicable;

        this.emitChange();
    }

    /**
     * Is a user required to give consent before we send them marketing material.
     */
    isEmailMarketingConsentRequired() {
        return this.isGDPRApplicable;
    }

    isLoggedIn() {
        return this.loggedIn;
    }

    getLanguage() {
        return this.language;
    }

    dismissAuthModal() {
        this.isAuthModalHidden = true;

        this.emitChange();
    }

    showAuthModal() {
        this.isAuthModalHidden = false;

        this.emitChange();
    }

    isAuthModalVisible() {
        return !this.loggedIn && !this.isAuthModalHidden;
    }
}



// WEBPACK FOOTER //
// ./js/launch/stores/UserStore.ts